import { Box } from '@mui/material';
import { memo } from 'react';
import type { WebhookBusinessSummaryRow } from 'utils/webhook-monitoring.utils';
import { DetailsLabelValue } from 'components/DetailsModal/DetailsLabelValue';

type Translate = (key: string) => string;

type Props = {
	rows: WebhookBusinessSummaryRow[];
	t: Translate;
	summaryPanelSx: object;
};

export const DetailsBusinessSection = memo(function DetailsBusinessSection({ rows, t, summaryPanelSx }: Props) {
	if (rows.length === 0) {
		return null;
	}

	return (
		<Box sx={{ WebkitFontSmoothing: 'antialiased' }}>
			<Box sx={summaryPanelSx}>
				{rows.map((bizRow, index) => (
					<DetailsLabelValue
						key={`${bizRow.labelKey}-${index}`}
						label={t(bizRow.labelKey)}
						value={bizRow.translateValue ? t(bizRow.value) : bizRow.value}
					/>
				))}
			</Box>
		</Box>
	);
});
